export default {
  methods: {
    destroyed() {
      window.onresize = null;
    },
    changeView(ele, cb) {
      if (window.ResizeObserver) {
        let resizeObserver = new window.ResizeObserver(() => {
          cb();
        });
        resizeObserver.observe(ele);
      } else {
        cb();
        window.onresize = () => {
          cb();
        };
      }
    },
  },
};
